import React from 'react';
import { roles } from '@nxsys/store/constants';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);
const DocumentList = React.lazy(
  () => import('../../../modules/documents/Listing/index'),
);

const DocumentsAgencyList = React.lazy(
  () =>
    import(
      '../../../modules/documents/Listing/DocumentList/DocumentsAgencyList'
    ),
);

const DocumentEmployeeList = React.lazy(
  () =>
    import(
      '../../../modules/documents/Listing/DocumentList/DocumentsEmployeeList'
    ),
);

export const documentsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/documents',
    element: <DocumentList />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/documents/employees-subcontractors',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/documents/employees-subcontractors/:activeTab',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.agency],
    path: '/agency-documents',
    element: <DocumentsAgencyList />,
  },
  {
    permittedRole: [roles.employee],
    path: '/employee-documents',
    element: <DocumentEmployeeList />,
  },
];
